import React from 'react';
import { METRICS } from '../data/landing';
export function MetricsBar() {
  return <section className="bg-cream pb-12 md:pb-16" aria-label="El Mega Pack en cifras" data-id="element-107" data-mp="uz2t5z7481e2">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-108" data-mp="19nqihnqdbevk">
        <dl className="grid grid-cols-4 rounded-[14px] border border-line bg-cream-soft py-5" data-id="element-109" data-mp="19oig143izmoh">
          {METRICS.map(metric => <div key={metric.label} className="flex flex-col items-center justify-start px-1 text-center" data-id="element-110" data-mp="14v5syyehvnxu">
              <dt className="order-2 mt-1 text-[10px] font-medium tracking-[0.02em] text-ink-muted" style={{
            fontSize: "14px"
          }} data-id="element-111" data-mp="1doah6vqlaqjt">
                {metric.label}
              </dt>
              <dd className="order-1 text-[20px] font-extrabold tracking-[-0.02em] text-ink md:text-[26px]" data-id="element-112" data-mp="1nmynix97ph7o">
                {metric.value}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}